<template>
  <div
    class="mt-3"
    :class="Loading ? 'disable' : ''"
    style="position: relative;"
  >
    <div>
      <span>Show </span>
      <b-select style="max-width: 100px;" class="ml-1 mr-1" v-model="pg_size">
        <option :value="+10">10</option>
        <option :value="+25">25</option>
        <option :value="+50">50</option>
        <option :value="+100">100</option>
      </b-select>
      <span>entries</span>
    </div>

    <table class="table table-hover mt-2 mb-2">
      <thead>
        <tr>
          <th scope="col">Date</th>
          <th scope="col">Detail</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(history, i) in clientUsersHistoryData.Result" :key="i">
          <td scope="col">{{ history.date }}</td>
          <td scope="col">{{ history.detail }}</td>
        </tr>
        <tr v-if="!clientUsersHistoryData.Result">
          <td colspan="2" class="text-center">No Records Found.</td>
        </tr>
      </tbody>
    </table>

    <!-- page Number -->
    <div
      class="d-flex mb-2"
      style="align-items: center;"
      v-if="clientUsersHistoryData.Result"
    >
      <div style="flex-grow: 1;" class="pl-2">
        <p>
          Showing {{ (pg_num - 1) * pg_size + 1 }} to
          {{ UpperLimit() }}
          of {{ clientUsersHistoryData.totalRecords }} entries
        </p>
      </div>
      <div class="pr-2">
        <Pagination
          :data="clientUsersHistoryData.Result"
          :totalPages="Math.ceil(clientUsersHistoryData.totalRecords / pg_size)"
          :total="clientUsersHistoryData.totalRecords"
          :perPage="pg_size"
          :currentPage="pg_num"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
    <!-- page Number -->
    <div v-if="Loading === true">
      <div class="centered-spinner">
        <a-spin />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoleHistory",
  data() {
    return {
      Loading: false,
      pg_num: 1,
      pg_size: 10,
    };
  },
  watch: {
    pg_size() {
      this.updateData();
    },
  },
  computed: {
    clientUsersHistoryData() {
      return this.$store.state.settings.clientUsersHistoryData;
    },
  },
  methods: {
    onPageChange(page) {
      console.log("page changed", page);
      this.pg_num = page;
      try {
        this.updateData();
      } catch (error) {
        console.log(error);
      }
      window.scrollTo(0, 0);
    },
    UpperLimit() {
      return this.clientUsersHistoryData.totalRecords <
        this.pg_num * this.pg_size
        ? this.clientUsersHistoryData.totalRecords
        : this.pg_num * this.pg_size;
    },
    updateData() {
      this.$store
        .dispatch("settings/getClientUsersHistory", {
          params: {
            userId: this.$route.query.Id,
            pg_num: this.pg_num,
            pg_size: this.pg_size,
          },
          data: {
            search_term: "",
            pg_num: this.pg_num,
            pg_size: this.pg_size,
            sort_field: "",
            sort_order: "",
          },
        })
        .then(() => {
          this.Loading = false;
        });
    },
  },
  created() {
    this.Loading = true;
    this.updateData();
  },
};
</script>

<style scoped>
.disable {
  opacity: 0.5;
  pointer-events: none;
}
.centered-spinner {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
</style>
